import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.js';

/**
 * Relance une requête échouée ? Une réponse de l'API en 4xx est DÉFINITIVE
 * (galerie introuvable, droit refusé, conflit) : la rejouer ne change rien et
 * faisait attendre ~7 s « Chargement… » devant une fiche inexistante (recette
 * du 5 octobre). Seule une panne passagère (5xx, réseau) vaut une reprise, deux
 * fois au plus.
 */
export function doitRelancer(tentativesFaites: number, erreur: unknown): boolean {
  if (erreur instanceof ApiError && erreur.status >= 400 && erreur.status < 500) return false;
  return tentativesFaites < 2;
}

/** Le client de requêtes de l'application. */
export function creerQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions: { queries: { retry: doitRelancer } } });
}
